/* Copyright (C) NewFoundry 2022 All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
"use strict";

var _defineProperty = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _classCallCheck = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.style = exports.mapStateToProps = exports.mapDispatchToProps = exports.name = exports.LeadsForm = void 0;

var react_1 = __importDefault(require("react"));

var brightsmith_redux_1 = require("brightsmith-redux");

var LeadsFormHelper_1 = __importDefault(require("./helpers/LeadsFormHelper"));

var StyleUtils_1 = __importDefault(require("./utils/StyleUtils"));

var brightsmith_core_1 = require("brightsmith-core");

var BrightsmithDb = brightsmith_core_1.Db.BrightsmithDb;
var name = 'LeadsForm';
exports.name = name;

var LeadsForm = function LeadsForm(_ref) {
  var Button = _ref.Button,
      Check = _ref.Check,
      Frame = _ref.Frame,
      Text = _ref.Text,
      Input = _ref.Input,
      Select = _ref.Select,
      styles = _ref.styles;
  return /*#__PURE__*/function (_react_1$default$Comp) {
    _inherits(_class, _react_1$default$Comp);

    var _super = _createSuper(_class);

    function _class(props) {
      var _this;

      _classCallCheck(this, _class);

      _this = _super.call(this, props);
      _this.state = {
        errors: {},
        isSubmitting: false,
        showErrorsOnInput: false
      };
      _this.onChange = _this.onChange.bind(_assertThisInitialized(_this));
      _this.renderFields = _this.renderFields.bind(_assertThisInitialized(_this));
      _this.renderSubmit = _this.renderSubmit.bind(_assertThisInitialized(_this));
      _this.submitForm = _this.submitForm.bind(_assertThisInitialized(_this));
      return _this;
    }

    _createClass(_class, [{
      key: "onChange",
      value: function onChange(name, value) {
        var _this2 = this;

        var saveLead = this.props.saveLead;
        saveLead(name, value);
        process.nextTick(function () {
          return _this2.validateFields(_this2.state.showErrorsOnInput);
        });
      }
    }, {
      key: "renderFields",
      value: function renderFields(fields, classes, opts) {
        var _this3 = this;

        var _this$props = this.props,
            countryCode = _this$props.countryCode,
            leadData = _this$props.leadData;
        var errors = this.state.errors;

        var getOptions = function getOptions(options) {
          if (typeof options === 'function') {
            var country = leadData.country;

            if (country || countryCode) {
              return options(country || countryCode);
            }

            return [];
          }

          return options;
        };

        return fields.map(function (field) {
          var _a, _b, _c;

          var key = field.key,
              label = field.label,
              placeholder = field.placeholder;
          var error = errors[key];
          var value = leadData[key] || '';
          var options = getOptions(field.options);

          var Required = function Required() {
            return react_1.default.createElement(Text, {
              className: ['LeadsForm__Required', classes === null || classes === void 0 ? void 0 : classes.required],
              style: styles === null || styles === void 0 ? void 0 : styles.required
            }, field.required && '*');
          };

          var sizeClass = field.half ? classes === null || classes === void 0 ? void 0 : classes.half : classes === null || classes === void 0 ? void 0 : classes.fullWidth;
          var sizeStyle = field.half ? styles === null || styles === void 0 ? void 0 : styles.half : styles === null || styles === void 0 ? void 0 : styles.fullWidth;
          return react_1.default.createElement(Frame, {
            className: ['LeadsForm__input-wrapper', classes === null || classes === void 0 ? void 0 : classes.inputWrapper, sizeClass],
            style: Object.assign(Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.inputWrapper), sizeStyle),
            key: key
          }, ((_a = opts === null || opts === void 0 ? void 0 : opts.required) === null || _a === void 0 ? void 0 : _a.before) === true && react_1.default.createElement(Required, null), function () {
            switch (field.type) {
              case 'select':
                return react_1.default.createElement(Select, {
                  className: ['LeadsForm__Select', classes === null || classes === void 0 ? void 0 : classes.select, _defineProperty({}, classes === null || classes === void 0 ? void 0 : classes.error, error)],
                  name: key,
                  onChange: function onChange(val) {
                    return _this3.onChange(key, val);
                  },
                  options: options,
                  placeholder: placeholder,
                  style: styles === null || styles === void 0 ? void 0 : styles.select,
                  value: value
                });

              case 'check':
                return react_1.default.createElement(Check, {
                  className: ['LeadsForm__Check', classes === null || classes === void 0 ? void 0 : classes.check, _defineProperty({}, classes === null || classes === void 0 ? void 0 : classes.error, error)],
                  onChange: function onChange(e) {
                    return _this3.onChange(key, !value);
                  },
                  isSelected: !!value,
                  name: key,
                  label: label,
                  style: styles === null || styles === void 0 ? void 0 : styles.check
                });

              case 'text':
                return react_1.default.createElement(Input, {
                  className: ['LeadsForm__Input', classes === null || classes === void 0 ? void 0 : classes.input, _defineProperty({}, classes === null || classes === void 0 ? void 0 : classes.error, error)],
                  name: key,
                  onChange: function onChange(e) {
                    return _this3.onChange(key, e.target.value);
                  },
                  placeholder: placeholder,
                  style: styles === null || styles === void 0 ? void 0 : styles.input,
                  value: value
                });

              case 'phone':
                return react_1.default.createElement(Input, {
                  className: ['LeadsForm__Phone', classes === null || classes === void 0 ? void 0 : classes.input, _defineProperty({}, classes === null || classes === void 0 ? void 0 : classes.error, error)],
                  inputMode: "numeric",
                  name: key,
                  onChange: function onChange(e) {
                    return _this3.onChange(key, e.target.value);
                  },
                  pattern: "[0-9]*",
                  placeholder: placeholder,
                  style: styles === null || styles === void 0 ? void 0 : styles.input,
                  value: value
                });

              case 'html':
                return field.content;
            }
          }(), ((_b = opts === null || opts === void 0 ? void 0 : opts.required) === null || _b === void 0 ? void 0 : _b.before) !== true && ((_c = opts === null || opts === void 0 ? void 0 : opts.required) === null || _c === void 0 ? void 0 : _c.after) !== false && react_1.default.createElement(Required, null));
        });
      }
    }, {
      key: "renderInstructions",
      value: function renderInstructions(instructions, classes) {
        if (typeof instructions === 'string') {
          return react_1.default.createElement(Text, {
            className: ['LeadsForm__instructions', classes === null || classes === void 0 ? void 0 : classes.instructions],
            style: styles === null || styles === void 0 ? void 0 : styles.instructions
          }, instructions);
        }

        return instructions;
      }
    }, {
      key: "renderSmallPrint",
      value: function renderSmallPrint(smallPrint, classes) {
        if (typeof smallPrint === 'string') {
          return react_1.default.createElement(Text, {
            className: ['LeadsForm__small-print', classes === null || classes === void 0 ? void 0 : classes.smallPrint],
            style: styles === null || styles === void 0 ? void 0 : styles.smallPrint
          });
        }

        return smallPrint;
      }
    }, {
      key: "renderSubmit",
      value: function renderSubmit() {
        var _this$props2 = this.props,
            classes = _this$props2.classes,
            onCancel = _this$props2.onCancel,
            SubmitButtons = _this$props2.SubmitButtons,
            submitText = _this$props2.submitText;
        var _this$state = this.state,
            errors = _this$state.errors,
            isSubmitting = _this$state.isSubmitting;
        var hasErrors = Object.keys(errors).length > 0;

        if (SubmitButtons) {
          return react_1.default.createElement(SubmitButtons, {
            onCancel: onCancel,
            onSubmit: this.submitForm,
            submitDisabled: hasErrors,
            submitting: isSubmitting
          });
        }

        return react_1.default.createElement(Button, {
          className: ['LeadsForm__submit', classes === null || classes === void 0 ? void 0 : classes.submit],
          style: styles === null || styles === void 0 ? void 0 : styles.submit,
          onClick: this.submitForm
        }, submitText || 'Submit');
      }
    }, {
      key: "submitForm",
      value: function submitForm(e) {
        var leadData = this.props.leadData;
        var _this$props3 = this.props,
            configuration = _this$props3.configuration,
            model = _this$props3.model,
            onSubmit = _this$props3.onSubmit;
        var showErrors = true;
        var errors = this.validateFields(showErrors);
        var hasErrors = Object.values(errors).indexOf(true) > -1;

        if (onSubmit && !hasErrors) {
          this.setState({
            isSubmitting: true
          });
          onSubmit(leadData, model, configuration);
        } else {
          this.setState({
            showErrorsOnInput: true
          });
        }
      }
    }, {
      key: "validateFields",
      value: function validateFields(showErrors) {
        var _this$props4 = this.props,
            countryCode = _this$props4.countryCode,
            leadData = _this$props4.leadData,
            setLeadIsValid = _this$props4.setLeadIsValid,
            leadIsValid = _this$props4.leadIsValid;
        var formFields = LeadsFormHelper_1.default.getFormFields(this.props);
        var allFieldsAreValid = true;
        var errors = {};
        formFields.forEach(function (field) {
          var key = field.key;
          var value = leadData[key];
          errors[key] = false;

          if (field.required && [null, undefined, '', false].indexOf(value) >= 0) {
            errors[key] = true;
          }

          if (field.validate) {
            var validate = field.validate;
            var isValid = validate(leadData, field.required, {
              countryCode: countryCode
            });
            errors[key] = !isValid;
          }

          if (errors[key] && field.required) {
            allFieldsAreValid = false;
          }
        });

        if (leadIsValid !== allFieldsAreValid) {
          setLeadIsValid(allFieldsAreValid);
        }

        if (showErrors) {
          this.setState({
            errors: errors
          });
        }

        return errors;
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props5 = this.props,
            after = _this$props5.after,
            before = _this$props5.before,
            classes = _this$props5.classes,
            instructions = _this$props5.instructions,
            opts = _this$props5.opts,
            title = _this$props5.title,
            smallPrint = _this$props5.smallPrint,
            setLeadIsValid = _this$props5.setLeadIsValid;
        var formFields = LeadsFormHelper_1.default.getFormFields(this.props);
        return react_1.default.createElement(Frame, {
          className: ['LeadsForm__container', classes === null || classes === void 0 ? void 0 : classes.container],
          style: Object.assign({
            overflow: 'scroll'
          }, styles === null || styles === void 0 ? void 0 : styles.container)
        }, before, react_1.default.createElement(Frame, {
          className: ['LeadsForm__inner', classes === null || classes === void 0 ? void 0 : classes.inner],
          style: styles === null || styles === void 0 ? void 0 : styles.inner
        }, react_1.default.createElement(Text, {
          className: ['LeadsForm__title', classes === null || classes === void 0 ? void 0 : classes.title],
          style: styles === null || styles === void 0 ? void 0 : styles.title
        }, title || 'Your Personalized Summary'), this.renderInstructions(instructions, classes), react_1.default.createElement(Frame, {
          className: ['LeadsForm__fields', classes === null || classes === void 0 ? void 0 : classes.fields],
          style: styles === null || styles === void 0 ? void 0 : styles.fields
        }, this.renderFields(formFields, classes, opts), this.renderSmallPrint(smallPrint, classes), this.renderSubmit())), after);
      }
    }]);

    return _class;
  }(react_1.default.Component);
};

exports.LeadsForm = LeadsForm;
var mapDispatchToProps = {
  saveLead: brightsmith_redux_1.Actions.saveLead,
  setLeadIsValid: brightsmith_redux_1.Actions.setLeadIsValid
};
exports.mapDispatchToProps = mapDispatchToProps;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var api = state.api,
      app = state.app,
      leads = state.leads;
  var configuration = api.configuration;
  var countryCode = app.countryCode;
  var db = new BrightsmithDb(api);
  var model = db.getCurrentModel();
  var leadIsValid = leads.leadIsValid;
  return {
    configuration: configuration,
    countryCode: countryCode,
    leadData: leads,
    leadIsValid: leadIsValid,
    model: model
  };
};

exports.mapStateToProps = mapStateToProps;

var style = function style(theme) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;

  return {
    check: Object.assign({
      fontSize: 14,
      fontFamily: ((_a = theme === null || theme === void 0 ? void 0 : theme.base) === null || _a === void 0 ? void 0 : _a.fontFamily) || 'sans-serif',
      marginBottom: 10,
      marginLeft: 20,
      marginRight: 20,
      marginTop: 10
    }, (_b = theme === null || theme === void 0 ? void 0 : theme.LeadsForm) === null || _b === void 0 ? void 0 : _b.check),
    container: Object.assign({
      backgroundColor: '#f7f7f7',
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column',
      width: '100%'
    }, (_c = theme === null || theme === void 0 ? void 0 : theme.LeadsForm) === null || _c === void 0 ? void 0 : _c.container),
    error: Object.assign(Object.assign(Object.assign({}, StyleUtils_1.default.border('1px solid #f00')), {
      boxShadow: '0 0 4px 1px #f00',
      outline: 'none'
    }), (_d = theme === null || theme === void 0 ? void 0 : theme.LeadsForm) === null || _d === void 0 ? void 0 : _d.error),
    half: {
      width: '48%'
    },
    inner: {
      padding: 15
    },
    fullWidth: {
      width: '100%'
    },
    title: Object.assign({
      borderBottomWidth: 1,
      borderStyle: 'solid',
      fontWeight: '500',
      marginTop: 5,
      paddingBottom: 15,
      textAlign: 'center',
      textTransform: 'uppercase'
    }, (_e = theme === null || theme === void 0 ? void 0 : theme.LeadsForm) === null || _e === void 0 ? void 0 : _e.title),
    fields: Object.assign({
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      marginTop: 15,
      paddingLeft: 10,
      paddingRight: 10
    }, (_f = theme === null || theme === void 0 ? void 0 : theme.LeadsForm) === null || _f === void 0 ? void 0 : _f.inner),
    input: Object.assign({
      borderColor: (_g = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _g === void 0 ? void 0 : _g.secondary,
      borderRadius: 2,
      borderWidth: 1,
      flex: 1,
      fontSize: 14,
      fontFamily: ((_h = theme === null || theme === void 0 ? void 0 : theme.base) === null || _h === void 0 ? void 0 : _h.fontFamily) || 'sans-serif',
      fontWeight: '300',
      maxWidth: '100%',
      padding: 7,
      paddingLeft: 9,
      paddingRight: 9,
      '&::placeholder': {
        color: (_j = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _j === void 0 ? void 0 : _j.secondary,
        textTransform: 'uppercase'
      }
    }, (_k = theme === null || theme === void 0 ? void 0 : theme.LeadsForm) === null || _k === void 0 ? void 0 : _k.input),
    inputWrapper: Object.assign(Object.assign({
      display: 'flex',
      flexDirection: 'row'
    }, StyleUtils_1.default.margin('0 20px 10px')), (_l = theme === null || theme === void 0 ? void 0 : theme.LeadsForm) === null || _l === void 0 ? void 0 : _l.inputWrapper),
    instructions: Object.assign({}, (_m = theme === null || theme === void 0 ? void 0 : theme.LeadsForm) === null || _m === void 0 ? void 0 : _m.instructions),
    required: Object.assign({
      color: 'red',
      height: 10,
      paddingTop: 10,
      textAlign: 'center',
      width: 15
    }, (_o = theme === null || theme === void 0 ? void 0 : theme.LeadsForm) === null || _o === void 0 ? void 0 : _o.required),
    select: Object.assign({
      borderColor: (_p = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _p === void 0 ? void 0 : _p.secondary,
      borderRadius: 2,
      borderWidth: 1,
      flex: 1,
      fontSize: 14,
      fontFamily: ((_q = theme === null || theme === void 0 ? void 0 : theme.base) === null || _q === void 0 ? void 0 : _q.fontFamily) || 'sans-serif',
      fontWeight: '300'
    }, (_r = theme === null || theme === void 0 ? void 0 : theme.LeadsForm) === null || _r === void 0 ? void 0 : _r.select),
    submit: Object.assign({
      backgroundColor: (_s = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _s === void 0 ? void 0 : _s.secondary,
      borderRadius: 5,
      borderWidth: 0,
      color: '#fff',
      cursor: 'pointer',
      fontSize: 16,
      fontWeight: '500',
      marginTop: 15,
      padding: 12,
      textAlign: 'center',
      textTransform: 'uppercase'
    }, (_t = theme === null || theme === void 0 ? void 0 : theme.LeadsForm) === null || _t === void 0 ? void 0 : _t.submit)
  };
};

exports.style = style;